let __keyCounter = 0;

export function generateUniqueKey(): string {
	__keyCounter++;
	const uuidPart =
		typeof crypto !== "undefined" && crypto.randomUUID
			? crypto.randomUUID()
			: Math.random().toString(36).slice(2, 10);

	return `key-${__keyCounter}-${Date.now()}-${uuidPart}`;
}

export function generateUniqueKeys(count: number): string[] {
	return Array.from({ length: count }, () => generateUniqueKey());
}
